import { put, takeLatest, all, call, select } from 'redux-saga/effects';
import { setAction, getGroupPermissionsAction } from '../actions/teamGroupsPage';
import { getGroupsAction } from '../../../redux/actions/profile';
import { getGroups } from '../../../middleware/Profile';
import { getProfileConfig } from '../../../redux/selectors/profile';
import actionTypes from '../../../redux/actions/action-types';
import { snackBar } from 'highed';

import {
  getPermissions,
  getTeamGroupPermissionsWithTeamidAndGroupid,
  postTeamGroupUsingTeamid,
  delTeamGroupUsingTeamidAndGroupid,
  postTeamGroupPermissionUsingTeamidAndGroupidAndPermissionid as postPermission,
  delTeamGroupPermissionUsingTeamidAndGroupidAndPermissionid as delPermission,
  postTeamGroupUsingTeamidAndGroupid,
} from '../../../api/cloudApiGenerated';

export function* getAllPermissions(params) {
  try {
    let data = yield call(getPermissions);
    yield put(
      setAction({
        permissions: data.data,
      })
    );
  } catch (error) {
    yield put(
      setAction({
        error: 'loading permissions: ' + error.message.join(' '),
      })
    );
  }
}

export function* getGroupPermissions(params) {
  const { team, group } = params.data;

  try {
    let data = yield call(getTeamGroupPermissionsWithTeamidAndGroupid, team.id, group.id);
    const groupPermissions = data.map((permission) => permission.id);
    yield put(
      setAction({
        groupPermissionsDb: [...groupPermissions],
        groupPermissions: [...groupPermissions],
        groupId: group.id,
        groupName: group.name,
      })
    );
  } catch (error) {
    yield put(
      setAction({
        error: 'loading group permissions: ' + error.message.join(' '),
      })
    );
  }
}

export function* setGroup(params) {
  const { team, newGroupName } = params.data;

  if (newGroupName && newGroupName.length >= 2) {
    try {
      let data = yield call(postTeamGroupUsingTeamid, team.id, {
        name: newGroupName,
      });
      yield put(
        setAction({
          modal: false,
          newGroupName: '',
        })
      );
      yield put(getGroupsAction({ team }));
      snackBar('Group created');
    } catch (error) {
      yield put(
        setAction({
          error: 'adding new group: ' + error.message.join(' '),
        })
      );
    }
  } else {
    yield put(
      setAction({
        newGroupNameError: 'The group name needs to be at least 2 characters long',
      })
    );
  }
}

export function* updateGroup(params) {
  const { team, groups, groupId, newGroupName } = params.data;
  if (newGroupName === '') {
    yield put(setAction({ editGroupNameError: 'The group name cannot be empty.' }));
    return;
  }
  try {
    yield call(postTeamGroupUsingTeamidAndGroupid, team.id, groupId, { name: newGroupName });
    const id = groupId;
    groups.forEach((e) => {
      if (e.id === id) e.name = newGroupName;
    });
    yield put(
      setAction({ groups: groups, groupName: newGroupName, editGroupNameError: '', modal: false, newGroupName: '' })
    );

    snackBar('Group updated');
  } catch (error) {
    yield put(
      setAction({
        error: 'loading group permissions: ' + error.message.join(' '),
      })
    );
  }
}

export function* deleteGroup(params) {
  const { team, groupId } = params.data;
  try {
    yield call(delTeamGroupUsingTeamidAndGroupid, team.id, groupId);
    yield put(setAction({ editGroupNameError: '', modal: false, newGroupName: '' }));

    yield call(getGroups, {
      data: {
        team,
      },
    });

    const config = yield select(getProfileConfig);
    yield put(
      getGroupPermissionsAction({
        team,
        group: config.groups[0] || {},
      })
    );

    snackBar('Group deleted');
  } catch (error) {
    yield put(
      setAction({
        error: 'deleting group: ' + error.message.join(' '),
      })
    );
  }
}

export function* setGroupPermissions(params) {
  const { team, permissions, groupId, groupPermissions, groupPermissionsDb } = params.data;

  const transactions = [];
  permissions.forEach((permission) => {
    const teamId = team.id;
    const permissionId = permission.id;
    const checked = groupPermissions.indexOf(permissionId) >= 0;
    const wasChecked = groupPermissionsDb.indexOf(permissionId) >= 0;
    if (checked && !wasChecked) transactions.push(call(postPermission, teamId, groupId, permissionId));
    else if (!checked && wasChecked) transactions.push(call(delPermission, teamId, groupId, permissionId));
  });

  try {
    yield all(transactions);
    yield put(
      getGroupPermissionsAction({
        team,
        group: {
          id: groupId,
        },
      })
    );
    yield put(setAction({ unsavedChanges: false }));
    snackBar('Permissions changed');
  } catch (error) {
    yield put(
      setAction({
        error: 'saving group permissions: ' + error.message && error.message.join(' '),
      })
    );
  }
}

/** Watch functions */
export function* watchGetAllPermissions() {
  yield takeLatest(actionTypes.teamGroupsPage.getPermissions, getAllPermissions);
}
export function* watchGetGroupPermissions() {
  yield takeLatest(actionTypes.teamGroupsPage.getGroupPermissions, getGroupPermissions);
}
export function* watchSetGroup() {
  yield takeLatest(actionTypes.teamGroupsPage.setGroup, setGroup);
}
export function* watchUpdateGroup() {
  yield takeLatest(actionTypes.teamGroupsPage.updateGroup, updateGroup);
}
export function* watchDeleteGroup() {
  yield takeLatest(actionTypes.teamGroupsPage.deleteGroup, deleteGroup);
}
export function* watchSetGroupPermissions() {
  yield takeLatest(actionTypes.teamGroupsPage.setGroupPermissions, setGroupPermissions);
}

export default function* rootSaga() {
  yield all([
    watchGetAllPermissions(),
    watchGetGroupPermissions(),
    watchSetGroup(),
    watchUpdateGroup(),
    watchDeleteGroup(),
    watchSetGroupPermissions(),
  ]);
}
